import React, { useState } from "react";
import mailIcon from "../../../../assets/design-revamp-company/franchise-component/mail-icon.svg";
import { SendMailInvestee } from "../../../../components/SendMailInvestee";
import { SendMailLeaser } from "../../../../components/SendMailLeaser";
import InfoIconFacility from "../InfoIconFacilities";
import "./index.css";
import { useTranslation } from "react-i18next";
import "../../Facility/facility.css";

const EmailField = ({ label, secondLabel, isFranchise }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <div className="email-field">
        <div className="info-facility-tip">
          <InfoIconFacility text={t("SCOPE_INV_TEXT_TIP")} />
        </div>
        <label>{label}</label>
        <p style={{ marginBottom: 0 }}>{secondLabel}</p>
        <img
          src={mailIcon}
          alt="Mail Icon"
          width={22}
          height={22}
          onClick={() => setOpen(true)}
          style={{ cursor: "pointer" }}
        />
      </div>
      {open &&
        (isFranchise ? (
          <div className="modal-overlay" style={{ zIndex: "999999" }}>
            <SendMailLeaser setOpen={setOpen} />
          </div>
        ) : (
          <div className="modal-overlay" style={{ zIndex: "999999" }}>
            <SendMailInvestee setOpen={setOpen} />
          </div>
        ))}
    </>
  );
};

export default EmailField;
